var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-4 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#277A84",
    d: "M5.112,0.011c-2.802,0-5.073,2.273-5.073,5.074v53.841C0.039,61.729,2.311,64,5.112,64h45.775 c2.801,0,5.074-2.271,5.074-5.074V20.321L37.057,0.011H5.112z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E5B60",
    d: "M55.96,20.377v1H43.161c0,0-6.312-1.26-6.129-6.707c0,0,0.208,5.707,6.004,5.707H55.96z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    d: "M37.059,0.025v14.561c0,1.656,1.104,5.791,6.104,5.791h12.799 L37.059,0.025z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M27.094,39.334l2.105-2.104c0,0-18.439,0-18.704,0c0,0-0.361,0.016-0.362,0.401s0,1.159,0,1.347 c0,0.187,0.182,0.355,0.375,0.355C10.701,39.334,27.094,39.334,27.094,39.334z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M19.768,46.602l2.104-2.104c0,0-11.113,0-11.377,0c0,0-0.361,0.016-0.362,0.401c-0.001,0.387,0,1.16,0,1.347 s0.182,0.356,0.375,0.356C10.701,46.602,19.768,46.602,19.768,46.602z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M14.708,53.904l0.268-2.104c0,0-4.216,0-4.48,0c0,0-0.361,0.017-0.362,0.402s0,1.16,0,1.346 c0,0.187,0.182,0.356,0.375,0.356C10.701,53.904,14.708,53.904,14.708,53.904z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M15.588,53.873c0,0,1.672-0.03,2.015-0.112c0.342-0.082,0.406-0.146,0.531-0.271 s13.104-13.104,13.104-13.104s-0.494,0.42-1.592-0.682c-0.869-0.87-0.487-1.402-0.487-1.402s-12.75,12.729-12.99,12.988 c-0.24,0.26-0.252,0.404-0.274,0.509C15.874,51.904,15.588,53.873,15.588,53.873z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M30.742,36.714c-0.201,0.201-0.96,0.938-1.059,1.058c-0.097,0.121-0.184,0.227-0.104,0.58 c0.079,0.353,0.682,1.354,1.656,1.629c0,0,0.299,0.107,0.541-0.133c0.24-0.242,1.092-1.093,1.092-1.093s0.204-0.172,0.042-0.621 c-0.163-0.448-0.81-1.247-1.582-1.539C30.941,36.447,30.742,36.714,30.742,36.714z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExam);
export default __webpack_public_path__ + "static/media/exam.f091a2f25c0a2a1e3a832e64a57ecbdb.svg";
export { ForwardRef as ReactComponent };